import { supabase } from "../supabase/SupabaseClient";
import { traerTodas } from "./paginar";

/* El puerto: fichajes y trabajos.
 *
 * ── ESTAS DOS PANTALLAS SON DE MIRAR ──────────────────────────────────────
 *
 * Lo que se carga entra por WhatsApp: la gente de puerto ficha con la foto del
 * molinete y anota los trabajos desde el teléfono, con las manos sucias.
 * Duplicar acá la carga obligaría a adivinar en cuál de los dos lados se
 * anota, y el día que se acierte el que no es ese trabajo no aparece en el
 * parte del lunes. Es la lección de los dos talleres.
 *
 * Lo único que se escribe desde acá es **anular** un trabajo mal cargado, y
 * anular no es borrar: la fila queda.
 *
 * ── LO QUE DE VERDAD RESTRINGE ES LA RLS ──────────────────────────────────
 *
 * Las dos tablas piden `ver.puerto` del lado de la BASE. Sin el permiso estas
 * consultas vuelven vacías aunque se las llame desde la consola del navegador
 * — el menú decide qué baldosa se dibuja, y eso es comodidad. El fichaje son
 * los horarios de dos personas, así que la pared tiene que estar del otro lado.
 */

/* Los fichajes de un período. Se pide un rango y no «los últimos N»: la
 * pregunta de esta pantalla es «¿qué pasó esta semana?», y un tope de filas
 * contestaría distinto según cuánto fichó la gente. */
export async function fichajes(desde, hasta) {
  return traerTodas(() =>
    supabase
      .from("puerto_fichajes")
      .select(
        "id, numero, persona, rol, tipo, recibido_en, hora_foto, foto, dudas",
        { count: "exact" },
      )
      .gte("recibido_en", desde)
      .lt("recibido_en", hasta)
      .order("recibido_en", { ascending: false })
      // Dos fichajes en el mismo instante empatan; el id desempata.
      .order("id", { ascending: false }),
  );
}

/* Los trabajos anotados, del más nuevo al más viejo.
 *
 * Los anulados NO se piden. La fila queda en la base —anular no es borrar— y
 * la pantalla que se mira todos los días es la de lo que vale.
 */
export async function trabajos(limite = 200) {
  const { data, error } = await supabase
    .from("puerto_trabajos")
    .select("id, interno, tarea, persona, rol, creado_en, fotos")
    .is("anulado_en", null)
    .order("creado_en", { ascending: false })
    .limit(limite);
  if (error) throw error;
  return data || [];
}

/* Anular un trabajo mal cargado.
 *
 * NO BORRA, con el mismo criterio que anular un movimiento y que cancelar un
 * ticket: que alguien haya decidido que ese trabajo no va es parte de la
 * historia, y hacerlo desaparecer deja el historial del camión sin poder
 * explicar por qué hay un hueco.
 *
 * Queda con QUIÉN lo anuló. Es la pregunta que aparece el día que alguien
 * busca un trabajo que cargó y no está.
 */
export async function anularTrabajo(id, mail) {
  const { error } = await supabase
    .from("puerto_trabajos")
    .update({ anulado_en: new Date().toISOString(), anulado_por: mail || null })
    .eq("id", id);
  if (error) throw error;
}

/* Los buckets del puerto. Son DOS y no uno, a propósito: `fichajes` guarda a
 * una PERSONA fichando —su horario, su cara— y `roturas` la chapa de un
 * camión. Cosas de distinta sensibilidad no comparten bucket, que es la regla
 * que `vale_archivo` de FlotaBot ya tiene escrita del lado que las sube.
 */
export const BUCKET_FICHAJES = "fichajes";
export const BUCKET_ROTURAS = "roturas";

/* Una foto del puerto, con un link firmado que dura una hora.
 *
 * LOS DOS BUCKETS SON PRIVADOS y tienen que seguir siéndolo. Público sería una
 * URL que se comparte sola y que después no se puede despublicar. El link que
 * quede pegado en un chat se muere solo.
 *
 * EL BUCKET ES UN PARÁMETRO Y NO DOS FUNCIONES. Lo único que cambia es el
 * nombre; con `linkFichaje` y `linkRotura` habría dos copias de la misma
 * llamada y el día que se mueva la vigencia del link una se quedaría con la
 * vieja. El default es `fichajes` porque es el que ya estaba.
 *
 * Devuelve `null` cuando no se pudo firmar, que la pantalla dice distinto de
 * «esta fila no tiene foto» — una es un problema nuestro y la otra un dato que
 * falta.
 *
 * ── Y ESTO NO ANDABA HASTA HOY ────────────────────────────────────────────
 *
 * `storage.objects` tiene RLS y estos buckets no tenían NI UNA política, así
 * que `createSignedUrl` devolvía error para cualquiera que no fuera
 * `service_role`: el bot subía la foto, la fila guardaba la ruta, y de este
 * lado nunca se podía abrir. No fallaba de forma visible —esta función
 * devuelve `null` y la pantalla lo dice bien— y no había mordido porque
 * todavía no hay ningún fichaje cargado. La política se agregó con la
 * migración de las roturas, y la llave es la misma que abre la fila:
 * `ver.puerto`.
 */
export async function linkFoto(ruta, bucket = BUCKET_FICHAJES) {
  if (!ruta) return null;
  const { data, error } = await supabase.storage
    .from(bucket || BUCKET_FICHAJES)
    .createSignedUrl(ruta, 3600);
  if (error) return null;
  return data?.signedUrl || null;
}
